import { ajax } from "../utils";

class Wish {
  static bindWishButtons(/*searchWishlist = []*/) {
    const btnWishlist = document.querySelectorAll('button[data-wishlist]');
    if (btnWishlist.length > 0) {
      btnWishlist.forEach(function (button) {
        if (button.dataset.experienceId) {
          const formData = new FormData();
          formData.append('experience_id', button.dataset.experienceId);

          button.addEventListener('click', function () {
            ajax('/wish/toggle', function (data) {
              if (data.wish !== true) {
                // added wish
                button.querySelector('i').classList.remove('icon-heart');
                button.querySelector('i').classList.add('icon-heart-filled', 'text-red');
                button.classList.add('btn-wishlist-active');
                button.title = button.dataset.textRemove;

                //Search Page
                // searchWishlist.push(button.dataset.experienceId);
              } else {
                // removed wish
                button.querySelector('i').classList.remove('icon-heart-filled', 'text-red');
                button.querySelector('i').classList.add('icon-heart');
                button.classList.remove('btn-wishlist-active');
                button.title = button.dataset.textAdd;

                //Search Page
                // let index = searchWishlist.indexOf(button.dataset.experienceId);
                // if(index !== -1){
                //   searchWishlist.splice(index, 1);
                // }
              }
            }, 'POST', formData, {
              "X-CSRF-Token": document.cookie.replace(/(?:(?:^|.*;\s*)csrfToken\s*=\s*([^;]*).*$)|^.*$/, "$1"),
            });
          });
        }
      });
    }
  }
}

export default Wish;
